module.exports = __webpack_public_path__ + "img/四川省第二中医院.034459d0.png";